import styles from "@/components/CreditOffer/components/SideDrawer/CreditOfferGroup/CreditOffersGroup.module.scss";
import { CreditIllustration } from "@/types/cobeTypes.ts";

type CardContentProps = CreditIllustration & {
  isList: boolean;
  index: number;
};

export const CreditOffersCardContent = ({
  creditRate,
  creditTerm,
  creditAmount,
  financialProductType,
  holidayPeriod,
  totalRepaymentAmount,
  repaymentAmount,
  repaymentCount,
  isList,
  index,
}: CardContentProps) => {
  if (financialProductType === "DEFERRED_IBC") {
    return (
      <>
        <p
          className={styles.creditOfferCard__title}
          data-testid="credit-offer-card-title"
        >
          <span>Buy now, pay later</span>
        </p>
        <p className={styles.creditOfferCard__subtitle}>
          Pay your balance in full within <span>{holidayPeriod?.display}</span>{" "}
          and pay no interest
        </p>
        <p className={styles.creditOfferCard__content}>
          For the first {holidayPeriod?.display}, choose when and how much you
          pay
        </p>
        <p className={styles.creditOfferCard__content}>
          After {holidayPeriod?.display}, pay {creditRate?.display} APR on any
          remaining balance over {creditTerm?.display}
        </p>
        <p className={styles.creditOfferCard__content}>
          <span>
            Interest on the remaining balance is charged from the date of
            purchase.
          </span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Product cost: <span>{creditAmount?.display}</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Total credit: <span>{creditAmount?.display}</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Pay in full within <span>{holidayPeriod?.display}</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Interest: <span>None</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Total amount payable: <span>{creditAmount?.display}</span>
        </p>
        <hr className={styles.creditOfferCard__divider} />
        <p className={styles.creditOfferCard__subtitle}>
          Or pay <span>nothing</span> for <span>{holidayPeriod?.display}</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Then {repaymentCount} monthly payments of:{" "}
          <span>{repaymentAmount?.display}</span>
        </p>
        <p className={styles.creditOfferCard__content}>
          Interest rate: <span>{creditRate?.display} APR </span>
          {` (Fixed)`}
        </p>
        <p className={styles.creditOfferCard__content}>
          Total amount payable: <span>{totalRepaymentAmount?.display}</span>
        </p>
      </>
    );
  }
  return (
    <>
      {!isList && (
        <p
          className={styles.creditOfferCard__title}
          data-testid="credit-offer-card-title"
        >
          <span>{creditRate.display} APR</span>
        </p>
      )}
      <p className={styles.creditOfferCard__subtitle}>
        {index === 0 ? "Pay " : "Or pay "}
        <span>{repaymentAmount?.display} per month</span> over{" "}
        <span>{creditTerm?.display}</span>
      </p>
      <p className={styles.creditOfferCard__content}>
        Product cost: <span>{creditAmount?.display}</span>
      </p>
      {financialProductType === "IBC" && (
        <p className={styles.creditOfferCard__content}>
          Total amount payable: <span>{totalRepaymentAmount?.display}</span>
        </p>
      )}
      <p className={styles.creditOfferCard__content}>
        Interest rate:{" "}
        <span>
          {creditRate?.display} APR
          {financialProductType === "IBC" && ` Representative`}
        </span>
        {` (Fixed)`}
      </p>
    </>
  );
};
